import "./ChartLegend.css";

import { thousandsFormatter } from "../../../utils";
import { ChartProps } from "../models";

type ChartLegendVariant = "Primary" | "Secondary";

interface ChartLegendProps extends ChartProps {
  colours: string[];
  hasData: boolean;
  defaultValue?: string | null;
  showValues?: boolean;
  variant?: ChartLegendVariant;
}

export const ChartLegend = ({
  data,
  colours,
  defaultValue = null,
  hasData,
  showValues = true,
  variant = "Primary",
}: ChartLegendProps): JSX.Element => {
  return (
    <div className="ChartLegend">
      <table>
        <tbody>
          {Object.keys(data).map((key, idx) => {
            return (
              <tr key={key}>
                {variant === "Primary" && (
                  <td>
                    <div className="ChartLegendBox" style={{ backgroundColor: colours[idx] }} />
                  </td>
                )}
                {showValues && (
                  <td
                    className={hasData ? "ChartLegendValue" : "ChartLegendNoValue"}
                    style={variant === "Secondary" ? { color: colours[idx] } : undefined}
                  >
                    <p className="body2">
                      {hasData ? thousandsFormatter.format(data[key]).toLowerCase() : defaultValue}
                    </p>
                  </td>
                )}
                <td className={showValues ? undefined : "RowPadding"}>
                  <p className="body2">{key}</p>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
